import { CACHE_CLEAR_ARTICLE, CACHE_CLEAR_TAGS } from './actions';
import HTTP from './../lib/HTTP';

const state = {};

const mutations = {};

const actions = {
    [CACHE_CLEAR_ARTICLE](context, data) {
        return new Promise((resolve, reject) => {
            HTTP.post(`cache/article`, data).then((res) => {
                console.log(res);
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    },
    [CACHE_CLEAR_TAGS](context, data){
        return new Promise((resolve, reject) => {
            HTTP.post(`cache/tags`, data).then((res) => {
                console.log(res);
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    }
};

export default {
    state,
    mutations,
    actions,
};
